import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapProfile = React.lazy(function () {
    return import('../../bootstrap-components/components/BTProfile');
});
var bootStrapProfile = function (props) {
    return (React.createElement(BootStrapProfile, __assign({}, props)));
};
var Profile = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapProfile(props);
            break;
        default:
            componentToDisplay = bootStrapProfile(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Profile.defaultProps = {
    styleName: 'primary',
    name: 'ProfilePicture',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Profile;
//# sourceMappingURL=Profile.js.map